import React from 'react';
export function EngagementsSection() {
  return <section id="engagements" className="py-24 md:py-32 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-26">
      <div className="mb-20 sticky top-20 md:static bg-white pb-6 md:pb-0 -mx-6 px-6 md:mx-0 md:px-0 z-10" data-id="element-27">
        <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-28">
          Engagements
        </h2>
        <h3 className="text-3xl md:text-4xl font-light text-black mb-4" data-id="element-29">
          Short-term. Embedded. Outcome-driven.
        </h3>
        <p className="text-xl text-gray-600 font-light" data-id="element-30">
          I step in when progress is at risk. Most of my work comes from
          investor and founder referrals, usually when things are piling up and
          momentum matters.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16" data-id="element-31">
        <div className="flex flex-col" data-id="element-32">
          <h4 className="text-xl font-medium text-black mb-6 pb-2 border-b border-gray-200 inline-block" data-id="element-33">
            Structure
          </h4>
          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-34">
            I embed quickly and work alongside you. I remove what's slowing
            execution in real time.
          </p>
          <ul className="space-y-3 mt-auto" data-id="element-35">
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-36">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-37"></span>
              Weekly leadership syncs
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-38">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-39"></span>
              Clear ownership and decision rights
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-40">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-41"></span>
              Tight feedback loops
            </li>
          </ul>
        </div>

        <div className="flex flex-col" data-id="element-42">
          <h4 className="text-xl font-medium text-black mb-6 pb-2 border-b border-gray-200 inline-block" data-id="element-43">
            Timeline
          </h4>
          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-44">
            I come in, build the execution layer, and step out. This work is
            designed to be temporary.
          </p>
          <ul className="space-y-3 mt-auto" data-id="element-45">
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-46">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-47"></span>
              8-10 week sprints
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-48">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-49"></span>
              Milestone-based scope
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-50">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-51"></span>
              Clear definition of "done"
            </li>
          </ul>
        </div>

        <div className="flex flex-col" data-id="element-52">
          <h4 className="text-xl font-medium text-black mb-6 pb-2 border-b border-gray-200 inline-block" data-id="element-53">
            Model
          </h4>
          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-54">
            I start small and earn trust. If momentum isn't real, I stop.
          </p>
          <ul className="space-y-3 mt-auto" data-id="element-55">
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-56">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-57"></span>
              30-day mutual trial
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-58">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-59"></span>
              Monthly retainer
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-60">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-61"></span>
              Scope adjusted weekly based on impact
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-20 pt-12 border-t border-gray-50" data-id="element-62">
        <div className="max-w-2xl" data-id="element-63">
          <p className="text-base text-gray-500 leading-relaxed" data-id="element-64">
            Founders often bring me back at later inflection points: fundraises,
            launches, leadership transitions.
          </p>
        </div>
      </div>
    </section>;
}